<template>
  <div class="analysis">
    <el-page-header @back="$router.go(-1)" content="数据分析"> </el-page-header>

    <el-tabs v-model="activeName" type="card" style="margin-top: 20px">
      <el-tab-pane label="团队分项成绩" name="1">
        <TeamItemScore />
      </el-tab-pane>
      <el-tab-pane label="团队视频数据" name="2" style="text-align: left" lazy>
        <TeamVideoAnalysis />
      </el-tab-pane>
      <el-tab-pane label="视频数据分析" name="3" style="text-align: left" lazy>
        <VideoAnalysis />
      </el-tab-pane>
      <el-tab-pane label="团队综合排名" name="4" lazy>
        <Ranking />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import Ranking from "./ranking.vue";
import TeamItemScore from "./teamItemScore.vue";
import TeamVideoAnalysis from "./teamVideoAnalysis.vue";
import VideoAnalysis from "./videoAnalysis.vue";
export default {
  components: { TeamItemScore, TeamVideoAnalysis, VideoAnalysis, Ranking },
  data() {
    return {
      activeName: "1",
    };
  },
};
</script>

<style lang="less" scoped>
.analysis {
  position: relative;
  padding: 20px 33px;
  background-color: #ffffff;
}
</style>